import React from "react";
import { Box } from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NotificationSkeleton = () => {
  return (
    <Box display="flex" p={2}>
      <Skeleton circle={true} borderRadius={50} width={40} height={40} />
      <Box width="80%" ml={2}>
        <Skeleton height="10px" width="100%" />
        <Skeleton height="10px" width="80%" />
        <Skeleton height="10px" width="60%" />
      </Box>
    </Box>
  );
};

export default NotificationSkeleton;
